/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import firebase from 'firebase/app';
import {
  Box,
  // Button,
  Card,
  CardContent,
  TextField,
  makeStyles,
  IconButton,
  // Modal,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CircularProgress
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Search as SearchIcon, X as CloseIcon } from 'react-feather';
import countries from '../../../utils/countries';

const useStyles = makeStyles((theme) => ({
  root: {},
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  modal: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3),
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '100%',
    maxHeight: '80%',
    overflowY: 'auto'
  }
}));

function countryToFlag(isoCode) {
  return typeof String.fromCodePoint !== 'undefined'
    ? isoCode
        .toUpperCase()
        .replace(/./g, (char) =>
          String.fromCodePoint(char.charCodeAt(0) + 127397)
        )
    : isoCode;
}

const Toolbar = ({ className, filter, setFilter, ...rest }) => {
  const classes = useStyles();
  const [postModalOpen, setPostModalOpen] = React.useState(false);
  const [currentFilter, setCurrentFilter] = React.useState({
    field: 'name',
    value: null
  });
  const [userMetaData, setUserMetaData] = React.useState();

  async function getUserMetaData() {
    return firebase
      .firestore()
      .doc('metaData/users')
      .get()
      .then((res) => setUserMetaData(res.data()));
  }

  React.useEffect(() => {
    getUserMetaData();
  }, []);

  const countryNames = userMetaData && Object.keys(userMetaData);
  const mago =
    userMetaData &&
    countries.filter((item) => countryNames.includes(item.code));
  const onlyCountries =
    userMetaData &&
    Object.entries(userMetaData)?.filter(([key]) => {
      switch (key) {
        case 'active':
          return false;
        case 'count':
          return false;
        default:
          return true;
      }
    });

  const countryMap = onlyCountries?.map((item) => ({
    code: item[0],
    value: item[1]
  }));

  function handleChange(e) {
    setCurrentFilter({ ...currentFilter, field: e.target.value });
  }

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Box mt={0}>
        {userMetaData ? (
          <Card>
            <CardContent>
              <Box
                flexDirection="row"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                {postModalOpen ? (
                  <Box flexDirection="row" display="flex" alignItems="center">
                    <FormControl
                      variant="outlined"
                      // fullWidth
                      style={{ maxWidth: 140, marginRight: 10 }}
                    >
                      <InputLabel id="demo-simple-select-label">
                        Search By
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Search By"
                        value={currentFilter.field}
                        onChange={handleChange}
                      >
                        <MenuItem value="name">Name</MenuItem>
                        <MenuItem value="surname">Surname</MenuItem>
                        <MenuItem value="email">Email</MenuItem>
                        <MenuItem value="uid">UID</MenuItem>
                      </Select>
                    </FormControl>
                    <TextField
                      // fullWidth
                      style={{ width: 400, marginRight: 10 }}
                      id="search-keywords"
                      variant="outlined"
                      placeholder="Enter your keywords"
                      onChange={(e) => {
                        setCurrentFilter({
                          ...currentFilter,
                          value: e.target.value
                        });
                      }}
                    />
                    <Button
                      disabled={
                        currentFilter &&
                        currentFilter.value === filter?.search?.value
                      }
                      onClick={() => setFilter({ search: currentFilter })}
                      variant="contained"
                      size="large"
                      color="primary"
                      className={classes.margin}
                    >
                      Search
                    </Button>
                  </Box>
                ) : (
                  <Autocomplete
                    fullWidth
                    style={{ maxWidth: 400 }}
                    id="page"
                    options={mago}
                    classes={{
                      option: classes.option
                    }}
                    onChange={(e, value) => {
                      if (value) {
                        setFilter({ country: value.code });
                      } else setFilter(null);
                    }}
                    autoHighlight
                    getOptionLabel={(option) => option.name}
                    renderOption={(option) => (
                      <div
                        style={{
                          display: 'flex',
                          width: '100%',
                          alignItems: 'center',
                          justifyContent: 'space-between'
                        }}
                      >
                        <p>
                          <span style={{ marginRight: 4 }}>
                            {countryToFlag(option.code)}
                          </span>
                          {option.name} ({option.code})
                        </p>
                        <span
                          style={{
                            color: '#999',
                            fontSize: 12,
                            fontWeight: 'bold'
                          }}
                        >
                          {
                            countryMap.find((item) => item.code === option.code)
                              .value
                          }
                        </span>
                      </div>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Filter By Country"
                        variant="outlined"
                        inputProps={{
                          ...params.inputProps
                        }}
                      />
                    )}
                  />
                )}
                <IconButton
                  onClick={() => {
                    setPostModalOpen(!postModalOpen);
                    if (postModalOpen) setFilter(null);
                  }}
                >
                  {postModalOpen ? <CloseIcon /> : <SearchIcon />}
                </IconButton>
              </Box>
            </CardContent>
          </Card>
        ) : (
          <CircularProgress />
        )}
      </Box>
    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string,
  filter: PropTypes.object,
  setFilter: PropTypes.func
};

export default Toolbar;
